exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-circled[data-v-3ce26599] {\n    background-color: var(--txt-copy-5);\n}\n.icon-circled[data-v-3ce26599]:hover {\n    background-color: var(--txt-copy-6);\n    fill: var(--txt-main);\n}\n.inline-svg-icon[data-v-3ce26599] {\n    fill: var(--txt-discrete);\n}\n.inline-svg-icon[data-v-3ce26599]:hover {\n    fill: var(--txt-main);\n}\n\n", ""]);

// exports
